import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
import React from "react";
import { DateDropdown, Checkbox } from "@tkww/gs-component-form";
import { Field as FormikField } from "formik";
import { Field as UnionField } from "@xo-union/tk-component-fields";
import { FormColumn, FormRow } from "@xo-union/tk-component-form-grid";
import { SeasonDropdown, YearDropdown } from "./seasonYearDropdown.js";
import WeddingDateFormat from "./weddingDateFormat.js";
import { DatePreference } from "./types.js";
export var TO_BE_ANNOUNCED_COPY = 'Date To Be Announced';
export var DateForm = function DateForm(_ref) {
  var _views;
  var currentView = _ref.currentView,
    config = _ref.config;
  if (currentView === null) return null;
  var views = (_views = {}, _defineProperty(_views, DatePreference.Season, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FormRow, null, /*#__PURE__*/React.createElement(FormColumn, {
    md: true
  }, /*#__PURE__*/React.createElement(FormikField, {
    key: "season",
    name: "season",
    label: "Season",
    component: SeasonDropdown,
    "data-testid": "season-field"
  })), /*#__PURE__*/React.createElement(FormColumn, {
    md: true
  }, /*#__PURE__*/React.createElement(FormikField, {
    key: "year",
    name: "year",
    label: "Year",
    component: YearDropdown,
    "data-testid": "year-field"
  }))))), _defineProperty(_views, DatePreference.Exact, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FormRow, null, /*#__PURE__*/React.createElement(FormColumn, {
    lg: true
  }, /*#__PURE__*/React.createElement(FormikField, {
    key: "weddingDateField",
    name: "date",
    label: "Wedding Date",
    component: DateDropdown,
    "data-testid": "wedding-date-field",
    readOnly: false
  }))), !!(config !== null && config !== void 0 && config.allowFormat) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FormRow, null, /*#__PURE__*/React.createElement(FormColumn, {
    md: true,
    style: {
      zIndex: 2
    }
  }, /*#__PURE__*/React.createElement(WeddingDateFormat, null))), /*#__PURE__*/React.createElement(FormRow, null, /*#__PURE__*/React.createElement(FormColumn, {
    md: true
  }, /*#__PURE__*/React.createElement(FormikField, {
    "data-testid": "hide-countdown-checkbox",
    name: "hideCountdown",
    component: Checkbox,
    disabledText: "Display Countdown on Homepage",
    enabledText: "Display Countdown on Homepage"
  })))))), _defineProperty(_views, DatePreference.Range, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FormRow, null, /*#__PURE__*/React.createElement(FormColumn, {
    md: true,
    style: {
      zIndex: 3
    }
  }, /*#__PURE__*/React.createElement(FormikField, {
    key: "weddingDateRangeStartField",
    name: "rangeStart",
    label: "Wedding Start Date",
    component: DateDropdown,
    readOnly: false,
    "data-testid": "range-start-field"
  }))), /*#__PURE__*/React.createElement(FormRow, null, /*#__PURE__*/React.createElement(FormColumn, {
    md: true
  }, /*#__PURE__*/React.createElement(FormikField, {
    key: "weddingDateRangeEndField",
    name: "rangeEnd",
    label: "Wedding End Date",
    component: DateDropdown,
    readOnly: false,
    "data-testid": "range-end-field"
  }))))), _defineProperty(_views, DatePreference.Tba, /*#__PURE__*/React.createElement(FormRow, null, /*#__PURE__*/React.createElement(FormColumn, {
    md: true
  }, /*#__PURE__*/React.createElement(UnionField, {
    style: {
      cursor: 'default'
    },
    "data-testid": "hide-date-placeholder",
    name: "hideDate",
    label: "Date Display",
    value: TO_BE_ANNOUNCED_COPY,
    readOnly: true
  })))), _defineProperty(_views, DatePreference.None, null), _views);
  return views[currentView];
};